import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const DealSearchPage = withSuspense(lazy(() => import('./deal-search')));
export default DealSearchPage;
